<template>
  <NuxtLink to="/">
    <AppBtn
      :height="height"
      :aria-label="getContent('app.logo_button_aria_label')"
    >
      <Transition>
        <img
          v-if="isImageVisible"
          width="48"
          :height="height"
          src="/app_logo.webp"
          alt="cnclr"
          :title="getContent('app.logo_aria_label')"
          class="shrink-0"
        >
      </Transition>
      <Transition>
        <span
          v-if="isTextVisible"
          class="logo-text font-rubik"
        >
          {{ getContent('preview.title') }}
        </span>
      </Transition>
    </AppBtn>
  </NuxtLink>
</template>

<script>
export default {
  props: {
    isImageVisible: {
      type: Boolean,
      default: true,
    },
    isTextVisible: {
      type: Boolean,
      default: true,
    },
    height: {
      type: [
        String,
        Number,
      ],
      default: 48,
    },
  },
  data: () => ({
    config: useRuntimeConfig(),
  }),
}
</script>

<style lang="scss" scoped>
.logo-text {
  color: $white;
  font-size: 32px;
  line-height: 38px;
  white-space: nowrap;
}
</style>
